"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClaimToken = void 0;
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const exchange_1 = require("@framework/exchange");
const useClaimToken = () => {
    const { execute: metaFnWithAllowance } = (0, react_hooks_eth_1.useAllowance)(async (_data, _form) => {
        return Promise.resolve().then(() => null);
    });
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)((values, form) => {
        const assets = (0, exchange_1.convertDatabaseAssetToTokenTypeAsset)(values.item.components);
        return metaFnWithAllowance({
            contract: values.account,
            assets,
        }, values, form);
    });
    const handleClaimTokenConfirm = async ({ data, form }) => {
        return metaFn(data, form);
    };
    return { handleClaimTokenConfirm };
};
exports.useClaimToken = useClaimToken;
//# sourceMappingURL=useClaimToken.js.map